(function ($) {

    'use strict';
    // 博客文章页添加侧栏目录和侧栏表单
    theme.initBlogArticle = function () {
        var titleArrs = [];  // 保存标题、滚动节点对应的关系
        var canScroll = true; // 是否可以滚动
        const IS_PF_PAGE = $('#__pf').length > 0; // 是否是pagefly页面
        const $articleContainer = IS_PF_PAGE ? $('#__pf') : $('article-page');
        const openIconHTML = `
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-164" viewBox="0 0 24 24">
                <g fill="#28BE44">
                    <path d="M19.583,4.965c0,0.17-0.059,0.319-0.176,0.449l-6.445,6.426l6.445,6.426c0.117,0.131,0.176,0.28,0.176,0.449
                        c0,0.17-0.059,0.319-0.176,0.449c-0.065,0.053-0.137,0.095-0.215,0.127c-0.078,0.033-0.156,0.049-0.234,0.049
                        s-0.156-0.016-0.234-0.049c-0.078-0.032-0.15-0.074-0.215-0.127l-6.426-6.445l-6.426,6.445c-0.065,0.053-0.137,0.095-0.215,0.127
                        c-0.078,0.033-0.156,0.049-0.234,0.049s-0.156-0.016-0.234-0.049c-0.078-0.032-0.15-0.074-0.215-0.127
                        c-0.117-0.13-0.176-0.279-0.176-0.449c0-0.169,0.059-0.318,0.176-0.449l6.445-6.426L4.759,5.414
                        c-0.117-0.13-0.176-0.279-0.176-0.449c0-0.169,0.059-0.318,0.176-0.449c0.13-0.117,0.28-0.176,0.449-0.176
                        c0.169,0,0.319,0.059,0.449,0.176l6.426,6.445l6.426-6.445c0.13-0.117,0.28-0.176,0.449-0.176c0.169,0,0.319,0.059,0.449,0.176
                        C19.524,4.646,19.583,4.796,19.583,4.965z"/>
                </g>
            </svg>
        `;  // 打开状态的icon
        const closeIconHTML = `
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-191" viewBox="0 0 24 24">
                <rect fill="#28BE44" x="3.438" y="5.479" width="17.375" height="1.25"/>
                <rect fill="#28BE44" x="3.438" y="11.104" width="17.375" height="1.25"/>
                <rect fill="#28BE44" x="3.438" y="16.729" width="17.375" height="1.25"/>
            </svg>
        `;  // 关闭状态的icon

        getAllTitle();
        insertSidebarDom();
        bindEvent();
        insertFormDOM();

        // 获取所有title
        function getAllTitle() {
            var $titleEles = $articleContainer.find('h2');
            $titleEles.map(function (index, item) {
                titleArrs.push({ title: $(item).text(), el: item, className: `h2-li-ele-${index}` });
            })
        }
        // 插入到DOM里
        function insertSidebarDom() {
            var cssText = `
              <style>
                .blog-sidebar{
                    position:fixed;
                    z-index:3;
                    left:30px;
                    top:150px;
                    width: 280px;
                    height: 600px;
                    background: #F8F9FA;
                    border-radius: 4px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #222222;
                    line-height: 20px;
                }
                p.title{
                    font-size: 16px;
                    font-weight: bold;
                    color: #222222;
                    line-height: 32px;
                    height:48px;
                    border-bottom:1px solid #D2DAE1;
                    padding: 8px 20px;
                    margin:0;
                }
                .blog-sidebar::-webkit-scrollbar{
                    width:2px;
                }
                li{
                    cursor:pointer;
                }
                .h2-ul-ele{
                    height:552px;
                    padding: 8px 10px;
                    list-style-type: disc;
                    overflow:auto;
                }
                .h2-ul-ele::-webkit-scrollbar{
                    width:2px;
                }
                .h2-li-ele{
                    font-size: 14px;
                    font-weight: 400;
                    color: #222222;
                    line-height: 20px;
                    list-style-position: inside;
                    padding-left:8px !important;
                }
                .h2-li-ele p{
                    margin:0;
                    display:inline-flex;
                    align-items:center;
                    margin:8px 0;
                    width:224px;
                }
                .h2-li-ele.active{
                    color: #222222;
                    background: #DCF1E2;
                    border-radius: 4px;
                }
                .h2-li-ele.active p{
                    border-right: 3px solid #28BE44;
                }
                .blog-icon{
                    display:none;
                    justify-content: center;
                    align-items: center;
                    position: fixed;
                    right: 16px;
                    bottom: 32px;
                    width: 56px;
                    height: 56px;
                    border-radius: 50%;
                    background: #fff;
                    box-shadow: 0px 4px 15px 0px rgba(0,0,0,0.08);
                    border: 1px solid #EAF0F5;
                    cursor: pointer;
                }
                .blog-icon svg{
                    width:31px;
                }
                #preview-bar-iframe{
                    display:none !important;
                }
                @media screen and (max-width:1340px) {
                    .blog-sidebar{
                        width:200px;
                    }
                    .h2-li-ele p{
                        width: 160px;
                        margin-left: -8px;  
                    }
                    .h2-ul-ele{
                        padding:8px;
                    }
                }
                @media screen and (max-width:1024px) {
                    .blog-sidebar{
                        bottom: 98px;
                        right: 15px;
                        width: 220px;
                        top: auto !important;
                        left: auto !important;
                        height: 360px;
                        display: none;
                        background:#fff;
                        box-shadow: 0px 7px 22px 0px rgba(0,0,0,0.1);
                        border-radius: 8px;
                    }
                    p.title{
                        height: 40px;
                        background: #EFF3F7;
                        border-radius: 8px 8px 0px 0px;
                        font-size: 14px;
                        font-weight: 600;
                        color: #222222;
                        line-height: 40px;
                        padding:0 24px;
                    }
                    .h2-ul-ele{
                        height:310px;
                        padding:6px 10px;
                        overflow:auto;
                        background:#fff;
                    }
                    .h2-li-ele {
                        font-size: 13px;
                        font-weight: 500;
                        color: #222222;
                        line-height: 18px;
                        border-radius: 4px;
                    }
                    .h2-li-ele p{
                        height:auto;
                        line-height:18px;
                        margin:6px 0;
                        width:176px;
                        margin-left: -5px;
                    }
                    .h2-li-ele.active p {
                        border-right:none;
                    }
                    .blog-icon{
                        display: flex;
                    }
                }
              </style>
            `
            var html = `${cssText}<div class="blog-sidebar"><p class="title">CONTENTS</p><ul class="h2-ul-ele">#licontent</ul></div>`;
            var liContent = titleArrs.map(item => {
                return `<li class="h2-li-ele ${item.className}"><p>${item.title}</p></li>`;
            });
            html = html.replace('#licontent', liContent.join(''));
            $(html).appendTo($articleContainer);

            // pc端设置目录的left值
            setBlogSidebarLeft();

            // 移动端显示小图标
            var iconHTML = `<div id="blog-icon" class="blog-icon">${closeIconHTML}</div>`;
            $(iconHTML).appendTo($articleContainer);

            // blog banner出现的时候不显示博客目录
            const $blogBanner = $('.blog-banner').get(0);
            if (isBlogBannerVisible($blogBanner)) {
                $('.blog-sidebar').hide();
                $("#blog-icon").css('display', 'none').html(closeIconHTML);
            }
        }
        // pc端设置目录的left值
        function setBlogSidebarLeft() {
            let left
            let width = $('.blog-sidebar').width();
            if (IS_PF_PAGE) {
                left = $('.pf-c').eq(0).get(0).getBoundingClientRect().left;
                left -= 305;
            } else {
                left = $('article.article-body').get(0).getBoundingClientRect().left;
                left = left - width - 56;
            }
            left = left <= 10 ? 10 : left;
            $('.blog-sidebar').css({ left: left + 'px' });
        }
        // 判断是否在可视区域，isHalf，是否出现到视口的中间位置
        function isElementInViewport(el, isHalf = false) {
            if (!el) {
                return false;
            }
            // 获取元素是否在可视区域
            var rect = el.getBoundingClientRect();
            var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
            return (
                rect.top >= 0 &&
                rect.top <= (isHalf ? (windowInnerHeight / 2) : windowInnerHeight)
            );
        }
        // 判断博客banner是否可视
        function isBlogBannerVisible(el) {
            if (!el) {
                return false;
            }
            // 获取元素是否在可视区域
            var { bottom } = el.getBoundingClientRect();
            return bottom >= getNavHeight();
        }
        // 判断移动端
        function isMobile() {
            return window.innerWidth <= 1024;
        }
        // 获取顶部的高度(header+topbar)
        function getNavHeight() {
            let headerHeight;
            if (window.innerWidth <= 1024) {
                headerHeight = $('.tt-mobile-header').height() || 0;
            } else {
                if ($('.tt-stuck-nav').is(':hidden')) {
                    headerHeight = $('.tt-desktop-header').height() || 0;
                } else {
                    headerHeight = $('.tt-stuck-nav').height() || 0;
                }
            }
            return headerHeight + ($('.aph_bar_bar').height() || 0);
        }
        // 绑定事件
        function bindEvent() {
            // 点击二级导航滚动到指定位置
            $('body').on('click', '.h2-li-ele', function (e) {
                $(this).addClass('active').siblings().removeClass('active');
                const text = $(this).text();
                const ele = (titleArrs.find(t => t.title == text) || {}).el;
                if (!ele) {
                    return;
                }
                const elePosTop = ele.getBoundingClientRect().top;
                const navHeight = getNavHeight();  // 顶部的高度(header+topbar)
                const eleTarPosTop = elePosTop + window.pageYOffset - navHeight; // 目标top
                window.scrollTo({ top: eleTarPosTop, behavior: "smooth" });
                canScroll = false;
                setTimeout(() => {
                    canScroll = true;
                }, 3000);
            })
            // 滚动的时候二级导航设置指定项active
            const $last = $('[data-pf-type="Section"]').last().get(0);
            const $footer = $('[data-section-id="footer"]').get(0);
            const $blogBanner = $('.blog-banner').get(0);
            $(window).on('scroll', function () {
                // 以下3种情况不显示侧栏目录和表单
                // 1.滚动到文章的最后一个节点
                // 2.滚动到footer
                // 3.博客banner显示的时候
                if (isElementInViewport($last, true) || isElementInViewport($footer) || isBlogBannerVisible($blogBanner)) {
                    $('.blog-sidebar').hide();
                    $('.blog-sidebar-form').hide();
                    $("#blog-icon").css('display', 'none').html(closeIconHTML);
                } else {
                    if (isMobile()) {
                        $("#blog-icon").css('display', 'flex');
                    } else {
                        $('.blog-sidebar').show();
                    }
                    $('.blog-sidebar-form').show();
                }
                if (!canScroll) {
                    return;
                }
                // 滚动的时候给侧栏的li加active
                titleArrs.map(item => {
                    const title = item.title;
                    const className = item.className;
                    const ele = (titleArrs.find(t => t.title == title) || {}).el;
                    if (!ele) {
                        return;
                    }
                    if (isElementInViewport(ele, true)) {
                        $(`.${className}`).addClass('active').siblings().removeClass('active');
                    }
                })
            });
            // 移动端点击小icon显示目录
            $("#blog-icon").click(function () {
                if ($('.blog-sidebar').is(':hidden')) {
                    $('.blog-sidebar').show();
                    $("#blog-icon").html(openIconHTML);
                } else {
                    $('.blog-sidebar').hide();
                    $("#blog-icon").html(closeIconHTML);
                }
            });
            // 视口改变，left要重新计算
            $(window).resize(() => {
                setBlogSidebarLeft();
            })
        }
        // 插入表单
        function insertFormDOM() {
            var cssText = `
            <style>
             .blog-sidebar-form{
                position:fixed;
                right:10px;
                top:100px;
                display:none;
                box-shadow: 0 7px 30px -1px rgb(0 0 0 / 10%);
                border-radius: 10px;
             }
             .blog-sidebar-form form{
                max-width: 300px !important;
             }
            
            </style>
          `
            var html = `${cssText}<div class="blog-sidebar-form"><div class="klaviyo-form-UnC2R8"></div></div>`;
            $(html).appendTo($articleContainer);

            // 监听表单的出现，垂直居中表单
            const observer = new MutationObserver(function () {
                const height = $('.blog-sidebar-form').height();
                if (height > 0) {
                    $('.blog-sidebar-form').css({
                        top: ($(window).height() - height) / 2 + 'px'
                    })
                }
            });
            observer.observe($('.blog-sidebar-form').get(0), { subtree: true, childList: true });
        }
    }
    theme.AssetsLoader.onPageLoaded(function () {
        theme.initBlogArticle();
    });
})(jQueryTheme);